import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MyTaskListComponent } from './myTaskList/myTaskList.component';
import { MyTaskDetailComponent } from './myTaskDetail/myTaskDetail.component';


import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageEvaluationModule} from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';

// common libraries


@NgModule({
  declarations: [
    MyTaskListComponent,
    MyTaskDetailComponent
  ],
  imports: [
    CommonModule,
    PHBHPLocalizePackageModule,
    PHBHPLayoutPackageModule,
    PHBHPFeaturePackageEvaluationModule,
    PhBhpUiModule
  ],
  exports: [
    //BsDatepickerModule
  ]
})
export class MyTaskModule { }
